import React, { useState, useEffect, useRef } from "react";
import client from "../contentfulClient";
import { format, parseISO } from "date-fns";
import { getConfig } from "../helpers/auth-helper";
import { getSrcPath } from "../helpers/auth-helper";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
let process = {
  env: {}
};
const Coupon = _ref => {
  var _JSON$parse, _posts$fields, _posts$fields2, _posts$fields3, _posts$fields4, _posts$fields5, _posts$fields6, _posts$fields7;
  let {
    navigate
  } = _ref;
  const headerConfig = getConfig();
  const hostSrc = getSrcPath();
  const [activehistoryType, setActiveIndex] = useState(0);
  const [memberCoupons, setMemberCoupons] = useState([]);
  const [bitData, setBitData] = useState([]);
  const [skeletonLoading, setSkeletonLoading] = useState(true);
  const [posts, setPosts] = useState([]);
  const [tncData, setTncData] = useState([]);
  const [couponCardImage, setCouponCardImage] = useState([]);
  const [copySuccess, setCopySuccess] = useState(-1);
  const [currentTab, setCurrentTab] = useState('ACTIVE');
  let memberId = localStorage.getItem("memberId");
  let memberCouponsCount = Math.trunc((_JSON$parse = JSON.parse(localStorage.getItem("memberData"))) === null || _JSON$parse === void 0 || (_JSON$parse = _JSON$parse.extra_data) === null || _JSON$parse === void 0 ? void 0 : _JSON$parse.total_privileges);
  const navigateToAllCoupons = () => {
    navigate("/allcoupons");
  };
  useEffect(() => {
    const fetchPostById = async () => {
      try {
        var _entry$fields, _entry$fields2, _entry$fields3;
        const entry = await client.getEntry("5uiWCn5q3hWfVCk8oo845c");

        // Check for linked assets or entries and resolve them
        const resolveLinks = async fields => {
          const resolvedFields = {
            ...fields
          };
          for (const key in fields) {
            const field = fields[key];
            if (Array.isArray(field)) {
              resolvedFields[key] = await Promise.all(field.map(async item => {
                if (item.sys && item.sys.type === "Link") {
                  return await client.getAsset(item.sys.id); // Resolve linked assets
                }
                return item;
              }));
            } else if (field.sys && field.sys.type === "Link") {
              if (field.sys.linkType === "Asset") {
                resolvedFields[key] = await client.getAsset(field.sys.id);
              } else if (field.sys.linkType === "Entry") {
                resolvedFields[key] = await client.getEntry(field.sys.id);
              }
            }
          }
          return resolvedFields;
        };
        const resolvedFields = await resolveLinks(entry.fields);
        setPosts({
          ...entry,
          fields: resolvedFields
        });
        // console.log({ ...entry, fields: resolvedFields })
        setTncData(resolvedFields.tnCContainer.map(item => ({
          question: item.fields.tnCTitle,
          answer: item.fields.tnCDescription,
          imgUrl: item.fields.tncImage.fields.file.url,
          fileName: item.fields.tncImage.fields.file.fileName
        })));
        // console.log(resolvedFields.tnCContainer.map((item) => ({
        //   question: item.fields.tnCTitle,
        //   answer: item.fields.tnCDescription,
        //   imgUrl: item.fields.tncImage.fields.file.url,
        //   fileName: item.fields.tncImage.fields.file.fileName
        // })))
        setCouponCardImage([(_entry$fields = {
          ...entry,
          fields: resolvedFields
        }) === null || _entry$fields === void 0 || (_entry$fields = _entry$fields.fields) === null || _entry$fields === void 0 || (_entry$fields = _entry$fields.raffleCardBlue) === null || _entry$fields === void 0 || (_entry$fields = _entry$fields.fields) === null || _entry$fields === void 0 || (_entry$fields = _entry$fields.file) === null || _entry$fields === void 0 ? void 0 : _entry$fields.url, (_entry$fields2 = {
          ...entry,
          fields: resolvedFields
        }) === null || _entry$fields2 === void 0 || (_entry$fields2 = _entry$fields2.fields) === null || _entry$fields2 === void 0 || (_entry$fields2 = _entry$fields2.raffleCardGold) === null || _entry$fields2 === void 0 || (_entry$fields2 = _entry$fields2.fields) === null || _entry$fields2 === void 0 || (_entry$fields2 = _entry$fields2.file) === null || _entry$fields2 === void 0 ? void 0 : _entry$fields2.url, (_entry$fields3 = {
          ...entry,
          fields: resolvedFields
        }) === null || _entry$fields3 === void 0 || (_entry$fields3 = _entry$fields3.fields) === null || _entry$fields3 === void 0 || (_entry$fields3 = _entry$fields3.raffleCardGrey) === null || _entry$fields3 === void 0 || (_entry$fields3 = _entry$fields3.fields) === null || _entry$fields3 === void 0 || (_entry$fields3 = _entry$fields3.file) === null || _entry$fields3 === void 0 ? void 0 : _entry$fields3.url]);
      } catch (error) {
        console.error("Error fetching the post:", error);
      }
    };
    fetchPostById();
  }, []);
  const tabRefs = useRef([]);
  useEffect(() => {
    getRaffles({
      bitStatus: "AVAILABLE,PARTIAL_USED"
    });
  }, []);
  const toggleFilter = index => {
    setSkeletonLoading(true);
    setActiveIndex(index);
    if (index == 0) {
      getRaffles({
        bitStatus: "AVAILABLE,PARTIAL_USED"
      });
      setCurrentTab('ACTIVE');
      scrollToTop();
    } else if (index == 1) {
      getRaffles({
        bitStatus: "CANCELLED,USED,EXPIRED"
      });
      setCurrentTab('EXPIRED');
      scrollToTop();
    }
  };
  const getRaffles = async params => {
    let bitStatusParam = "";
    if (params.bitStatus && params.bitStatus != "all") {
      bitStatusParam = "&status=".concat(params.bitStatus);
    }
    const url = hostSrc + "/bolapi/v3/members/".concat(memberId, "/privileges?cdc=COUPON&page_size=5").concat(bitStatusParam, "/");
    const headers = headerConfig;
    try {
      const response = await fetch(url, {
        method: "GET",
        headers: headers
      });
      let filteredData = await response.json();
      let bitReference = filteredData.map(item => item.bit_reference);
      try {
        const fetchPromises = bitReference.map(endpoint => fetch(hostSrc + "/bolapi/v1/bits/?member_id=".concat(memberId, "&bit_id=") + endpoint, {
          method: "GET",
          headers: headers
        }).then(res => res.json()));
        const responses = await Promise.all(fetchPromises);
        // console.log(responses);
        setBitData(responses);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
      setMemberCoupons(filteredData);
      setSkeletonLoading(false);
    } catch (error) {
      console.error("Error:", error);
    }
  };
  function pageTitleFunc(pageTitle) {
    if (pageTitle != undefined) {
      const pageTitleVar = pageTitle.replace(/\*\*(.*?)\*\*/, "&nbsp;<p>$1</p>");
      return pageTitleVar;
    }
  }
  function pageTitleBold(pageTitle) {
    if (pageTitle !== undefined) {
      const pageTitleVar = pageTitle.replace(/__(.*?)__/g, "<b style= 'font-weight:600'>$1</b>");
      return pageTitleVar;
    }
    return ""; // Handle undefined input gracefully
  }
  const handleShare = async (uniquePrivilegeCode, indexes) => {
    try {
      await navigator.clipboard.writeText(uniquePrivilegeCode);
      setCopySuccess(indexes); // Show success message
      setTimeout(() => setCopySuccess(-1), 2000);
    } catch (error) {
      console.log("Error copying to clipboard:", error);
    }
  };
  const scrollToTop = () => {
    window.scrollTo(0, 0);
  };
  useEffect(() => {
    scrollToTop();
  }, []);
  return /*#__PURE__*/React.createElement("div", {
    className: "coupon-container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "coupon-container-1",
    style: {
      backgroundImage: "url(".concat(posts === null || posts === void 0 || (_posts$fields = posts.fields) === null || _posts$fields === void 0 || (_posts$fields = _posts$fields.headerImage) === null || _posts$fields === void 0 || (_posts$fields = _posts$fields.fields) === null || _posts$fields === void 0 || (_posts$fields = _posts$fields.file) === null || _posts$fields === void 0 ? void 0 : _posts$fields.url, ")"),
      backgroundSize: "34%",
      backgroundRepeat: "no-repeat",
      backgroundPosition: "right 0px"
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "heading",
    dangerouslySetInnerHTML: {
      __html: pageTitleFunc(posts === null || posts === void 0 || (_posts$fields2 = posts.fields) === null || _posts$fields2 === void 0 ? void 0 : _posts$fields2.headerText)
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "headingDesc"
  }, posts === null || posts === void 0 || (_posts$fields3 = posts.fields) === null || _posts$fields3 === void 0 ? void 0 : _posts$fields3.headerDescription), typeof memberCouponsCount === "number" && !isNaN(memberCouponsCount) && /*#__PURE__*/React.createElement("div", {
    className: "raffleCount"
  }, /*#__PURE__*/React.createElement("div", {
    className: "raffleCount1"
  }, memberCouponsCount), /*#__PURE__*/React.createElement("div", {
    className: "raffleCount2"
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      fontSize: "14px",
      fontWeight: "500"
    }
  }, "COUPONS"), /*#__PURE__*/React.createElement("div", {
    style: {
      fontSize: "10px",
      fontWeight: "300"
    }
  }, "COLLECTED SO FAR")))), /*#__PURE__*/React.createElement("div", {
    className: "coupon-container-2"
  }, /*#__PURE__*/React.createElement("div", {
    className: "tab-container"
  }, ["active", "expired"].map((label, index) => /*#__PURE__*/React.createElement("div", {
    key: index,
    ref: el => tabRefs.current[index] = el,
    className: activehistoryType === index ? "tab selected-tab" : "tab",
    onClick: () => toggleFilter(index)
  }, label))), skeletonLoading ? /*#__PURE__*/React.createElement("div", {
    style: {
      width: "350px",
      margin: "auto auto auto 24px",
      padding: "10px 0"
    }
  }, /*#__PURE__*/React.createElement(Skeleton, {
    height: 165,
    width: 320,
    borderRadius: 10,
    count: 5,
    style: {
      opacity: "0.2",
      marginBottom: "10px"
    }
  })) : memberCoupons.length > 0 ? /*#__PURE__*/React.createElement("div", {
    style: {
      paddingLeft: "24px"
    }
  }, memberCoupons.map((item, index) => /*#__PURE__*/React.createElement("div", {
    key: index,
    className: "slide"
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "flex",
      height: "148px",
      width: "93%",
      backgroundImage: "url(".concat(currentTab == "ACTIVE" ? couponCardImage[0] : couponCardImage[2], ")"),
      backgroundSize: "100% 100%",
      backgroundRepeat: "no-repeat",
      marginBottom: "20px"
    }
  }, /*#__PURE__*/React.createElement("div", {
    id: "productImage",
    style: {
      display: "flex",
      width: "40%",
      justifyContent: "space-between",
      backgroundImage: "url(".concat(item.product.logo, ")"),
      backgroundSize: "100%",
      borderRadius: "8px 0 0 8px"
    }
  }), /*#__PURE__*/React.createElement("div", {
    style: {
      display: "flex",
      width: "60%",
      flexDirection: "column",
      padding: "15px 18px",
      lineHeight: "1.7",
      justifyContent: "space-between"
    }
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    style: {
      fontSize: "14px",
      fontWeight: "600",
      whiteSpace: "nowrap",
      textOverflow: "ellipsis",
      overflow: "hidden"
    }
  }, item.product.name), /*#__PURE__*/React.createElement("div", {
    style: {
      fontSize: "13px",
      fontWeight: "400",
      display: "-webkit-box",
      WebkitLineClamp: "3",
      WebkitBoxOrient: "vertical",
      overflow: "hidden",
      lineHeight: "1.4"
    }
  }, item.product.description)), currentTab == "ACTIVE" ? /*#__PURE__*/React.createElement("div", {
    onClick: () => handleShare(item.privilege_code, index),
    style: {
      fontSize: "13px",
      fontWeight: "600",
      border: copySuccess == index ? "1px dashed #0f9518" : "1px dashed #ADADAD",
      padding: "5px 10px",
      borderRadius: "4px",
      backgroundColor: copySuccess == index ? "#4dcf5733" : "#F6F6F633",
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center"
    }
  }, item.privilege_code, /*#__PURE__*/React.createElement("div", {
    className: copySuccess == index ? "fas fa-file" : ""
  })) : /*#__PURE__*/React.createElement("div", {
    className: "expiredCta"
  }, "EXPIRED")))))) : /*#__PURE__*/React.createElement("div", {
    style: {
      width: "fit-content",
      margin: "70px auto 15px",
      padding: "60px",
      border: "1px dashed rgb(173, 173, 173)",
      borderRadius: "10px",
      backgroundColor: "rgba(246, 246, 246, 0.2)"
    }
  }, "No Coupons Available") // Safe fallback content
  ), /*#__PURE__*/React.createElement("div", {
    className: "coupon-container-3",
    style: {
      backgroundImage: "url(".concat(posts === null || posts === void 0 || (_posts$fields4 = posts.fields) === null || _posts$fields4 === void 0 || (_posts$fields4 = _posts$fields4.goldenShadow) === null || _posts$fields4 === void 0 || (_posts$fields4 = _posts$fields4.fields) === null || _posts$fields4 === void 0 || (_posts$fields4 = _posts$fields4.file) === null || _posts$fields4 === void 0 ? void 0 : _posts$fields4.url, ")")
    }
  }, memberCoupons.length > 0 ? /*#__PURE__*/React.createElement("button", {
    className: "invite"
  }, /*#__PURE__*/React.createElement("div", {
    onClick: navigateToAllCoupons
  }, "View More")) : /*#__PURE__*/React.createElement("div", {
    style: {
      height: "35px"
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "heading",
    style: {
      lineHeight: "30px",
      display: "block",
      width: "200px",
      flexDirection: "row",
      margin: "0 auto"
    },
    dangerouslySetInnerHTML: {
      __html: pageTitleFunc(posts === null || posts === void 0 || (_posts$fields5 = posts.fields) === null || _posts$fields5 === void 0 ? void 0 : _posts$fields5.tnCHeading)
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "coupon-container-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "coupon-container-41"
  }, tncData === null || tncData === void 0 ? void 0 : tncData.map((item, index) => /*#__PURE__*/React.createElement(React.Fragment, {
    key: index
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      width: "48px",
      height: "48px"
    }
  }, /*#__PURE__*/React.createElement("img", {
    style: {
      width: "100%",
      maxHeight: "100%",
      objectFit: "cover"
    },
    src: item.imgUrl,
    alt: item.fileName
  })), index != Math.floor(tncData.length - 1) && /*#__PURE__*/React.createElement("div", {
    style: {
      width: "1px",
      height: "77px",
      backgroundColor: "#F1CB83",
      opacity: "20%"
    }
  })))), /*#__PURE__*/React.createElement("div", {
    className: "coupon-container-42"
  }, tncData === null || tncData === void 0 ? void 0 : tncData.map((item, index) => /*#__PURE__*/React.createElement("div", {
    key: index,
    style: {
      minHeight: "145px",
      padding: "0 18px"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      color: "white",
      fontSize: "12px",
      fontWeight: "600",
      letterSpacing: "1px",
      display: "block"
    },
    dangerouslySetInnerHTML: {
      __html: pageTitleBold(item.question)
    }
  }), /*#__PURE__*/React.createElement("div", {
    style: {
      color: "white",
      fontSize: "14px",
      fontWeight: "300",
      display: "block",
      opacity: "60%",
      textAlign: "justify"
    },
    dangerouslySetInnerHTML: {
      __html: pageTitleBold(item.answer)
    }
  }))))), (posts === null || posts === void 0 || (_posts$fields6 = posts.fields) === null || _posts$fields6 === void 0 || (_posts$fields6 = _posts$fields6.tnCFooter) === null || _posts$fields6 === void 0 || (_posts$fields6 = _posts$fields6.content) === null || _posts$fields6 === void 0 || (_posts$fields6 = _posts$fields6[0]) === null || _posts$fields6 === void 0 ? void 0 : _posts$fields6.content) && /*#__PURE__*/React.createElement("div", {
    style: {
      fontSize: "14px",
      fontWeight: "300",
      padding: "0 24px 50px"
    }
  }, /*#__PURE__*/React.createElement("p", {
    style: {
      display: "flex",
      flexDirection: "column"
    }
  }, posts === null || posts === void 0 || (_posts$fields7 = posts.fields) === null || _posts$fields7 === void 0 || (_posts$fields7 = _posts$fields7.tnCFooter) === null || _posts$fields7 === void 0 || (_posts$fields7 = _posts$fields7.content) === null || _posts$fields7 === void 0 || (_posts$fields7 = _posts$fields7[0]) === null || _posts$fields7 === void 0 ? void 0 : _posts$fields7.content.map((node, index) => {
    if (node.nodeType === "text") {
      return /*#__PURE__*/React.createElement("span", {
        key: index
      }, node.value);
    }
    if (node.nodeType === "hyperlink") {
      return /*#__PURE__*/React.createElement("a", {
        key: index,
        href: node.data.uri,
        target: "_blank",
        rel: "noopener noreferrer",
        style: {
          color: "#F1CB83",
          textDecoration: "none"
        }
      }, node.content[0].value);
    }
    return null;
  }))));
};
export { Coupon };